/** @format */

import React, { useContext, useEffect, useMemo } from "react";
import { Context } from "../stores/Provider";
import { getSession } from "../sessionStorage/sessionStorageMethod";
import { setIsLoading } from "../function/setIsLoading";
import { logoutAbnormalFunction } from "../function/logoutAbnormalFunction";
import {
  initApiModelType,
  statusRequestType,
  statusResponseEntryType,
  statusResponseType,
} from "../constance/typeModel";
import { initApiResponse, ToolChipDiv } from "../constance/constance";
import { GetMethod } from "../api/Api";
import styled from "styled-components";
import { fonts } from "../css/variables/fonts";
import { colors } from "../css/variables/colors";

const AnavailableDaySpan = styled.span`
  font-weight: bold;
  font-size: ${fonts.fontSizeRem("s")};
  margin-bottom: 32px;
  color: ${colors.themeColor("text_error")};
`;

const useContainerHooks = (isLogin: boolean, navigateByAgent: Function) => {
  const { state, dispatch } = useContext(Context);
  const isLoading = state.isLoading;
  const canceledFlag = state.user_status.cancel_flag;
  const serviceStatusData = state.service_status;
  const confirmDate = state.user_status.close_schedule_date;
  const serviceCodeList = state.service_code_list;
  const userInfoData = getSession("user");
  const entryId = userInfoData?.entry_id ?? null;

  const closeState = useMemo(() => {
    let returnState: {
      confirm_date: null | string;
      confirm_flag: boolean;
    } = {
      confirm_date: null,
      confirm_flag: false,
    };
    returnState = { confirm_date: state.user_status.close_schedule_date, confirm_flag: state.user_status.confirm_flag };
    return returnState;
  }, [state.user_status.close_schedule_date, state.user_status.confirm_flag]);

  const closingNoticeText = useMemo(() => {
    const closeServiceCodeList = serviceCodeList.split("/");
    const allText = closeServiceCodeList.length > 1 ? "すべて" : "";

    // 各テキスト格納
    const allGoText = (
      <ToolChipDiv>
        {`・お申込みの決済サービスが${allText}ご利用開始となりましたので、申込ID：${entryId}でのWeb申込システムのご利用が終了となります。\n  `}
        <AnavailableDaySpan>ご利用終了日：{confirmDate}</AnavailableDaySpan>
        {
          "\n・なお、お申込み内容は、ダッシュボード画面右下の「お申し込み情報ダウンロード」ボタンよりPDFでダウンロードが可能です。\n 必要に応じて、ご利用終了日までにダウンロードを行ってください。"
        }
      </ToolChipDiv>
    );
    const cvsCancelText = (
      <ToolChipDiv>
        {`・コンビニ決済サービスのキャンセル手続きが完了しましたので、申込ID：${entryId}でのWeb申込システムのご利用が終了となります。\n  `}
        <AnavailableDaySpan>ご利用終了日：{confirmDate}</AnavailableDaySpan>
        {
          "\n・なお、お申込み内容は、ダッシュボード画面右下の「お申し込み情報ダウンロード」ボタンよりPDFでダウンロードが可能です。\n 必要に応じて、ご利用終了日までにダウンロードを行ってください。"
        }
      </ToolChipDiv>
    );
    const cvsNgText = (
      <ToolChipDiv>
        {`・コンビニ決済サービスは審査の結果ご提供不可となりました。審査終了に伴い、申込ID：${entryId}でのWeb申込システムのご利用が終了となります。\n  `}
        <AnavailableDaySpan>ご利用終了日：{confirmDate}</AnavailableDaySpan>
        {
          "\n・なお、お申込み内容は、ダッシュボード画面右下の「お申し込み情報ダウンロード」ボタンよりPDFでダウンロードが可能です。\n 必要に応じて、ご利用終了日までにダウンロードを行ってください。"
        }
      </ToolChipDiv>
    );
    const allNgText = (
      <ToolChipDiv>
        {`・お申込みの決済サービスは審査の結果、ご提供不可となりました。審査終了に伴い、申込ID：${entryId}でのWeb申込システムのご利用が終了となります。\n  `}
        <AnavailableDaySpan>ご利用終了日：{confirmDate}</AnavailableDaySpan>
      </ToolChipDiv>
    );
    const allChancelText = (
      <ToolChipDiv>
        {`・お申込みの決済サービスは、${allText}キャンセル手続きが完了いたしました。キャンセルに伴い、申込ID：${entryId}でのWeb申込システムのご利用が終了となります。\n  `}
        <AnavailableDaySpan>ご利用終了日：{confirmDate}</AnavailableDaySpan>
      </ToolChipDiv>
    );

    const atobaraiNgText = (
      <ToolChipDiv>
        {`・あと払い決済サービスは審査の結果ご提供不可となりました。審査終了に伴い、申込ID：${entryId}でのWeb申込システムのご利用が終了となります。\n  `}
        <AnavailableDaySpan>ご利用終了日：{confirmDate}</AnavailableDaySpan>
        {
          "\n・なお、お申込み内容は、ダッシュボード画面右下の「お申し込み情報ダウンロード」ボタンよりPDFでダウンロードが可能です。\n 必要に応じて、ご利用終了日までにダウンロードを行ってください。"
        }
      </ToolChipDiv>
    );

    // 選択サービス全NGパターン
    let allNgFlag = true;
    closeServiceCodeList.forEach((selectedService) => {
      if (serviceStatusData[selectedService].status !== "NG") allNgFlag = false;
    });
    if (allNgFlag || state.user_status.before_status === "CHECK_NG") return allNgText;

    // 選択サービス全キャンセルパターン
    let allChancelFlag = true;
    closeServiceCodeList.forEach((selectedService) => {
      if (serviceStatusData[selectedService].status !== "CANCEL") allChancelFlag = false;
    });
    // 全サービスキャンセルか申込全体がキャンセルの時
    if (allChancelFlag || canceledFlag) return allChancelText;

    //  選択サービスにコンビニがあるかチェック
    if (serviceCodeList.includes("cvs")) {
      // クレカがキャンセル以外＆＆コンビニがキャンセルの時
      if (serviceStatusData.credit.status !== "CANCEL" && serviceStatusData.cvs.status === "CANCEL") {
        return cvsCancelText;
      }
      // クレカが審査NG以外＆＆コンビニが審査NGの時
      if (serviceStatusData.credit.status !== "NG" && serviceStatusData.cvs.status === "NG") {
        return cvsNgText;
      }
    }

    // emochiの場合、クレカが審査NG以外かつあと払いNGだったらクローズ文言を表示する
    if (state.zAccount === "emochi") {
      if (serviceStatusData.credit.status !== "NG" && serviceStatusData.atobarai.status === "NG") {
        return atobaraiNgText;
      }
    }

    // 上記の条件以外
    return allGoText;
  }, [state, serviceCodeList, serviceStatusData, confirmDate, canceledFlag]);

  //画面読み込み時ローディング表示、ページトップ移動後ローディングを消去
  useEffect(() => {
    const getResponse = async () => {
      setIsLoading(true, dispatch);
      const entryId = { entry_id: userInfoData.entry_id };
      let response: initApiModelType<statusResponseType> = initApiResponse;
      response = await GetMethod<statusRequestType, statusResponseType>(entryId, "/status");
      if (response.code !== 200 || response.response_data === undefined) {
        if (response.code === 401) {
          return logoutAbnormalFunction(response, dispatch, navigateByAgent, state.agentPath, state.zAccount);
        }
        setIsLoading(false, dispatch);
        return navigateByAgent("/system_error");
      }
      getServiceStatus(response.response_data.entry);
      setIsLoading(false, dispatch);
    };
    if (isLogin && state.user_status.status !== "" && state.user_status.status !== "ENTRING") getResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.user_status.status]);

  // 各サービス情報
  const getServiceStatus = (data: statusResponseEntryType) => {
    //初期表示ページトップと画面読み込みローディング非表示
    window.scrollTo(0, 0);
    dispatch({
      type: "set-context-data",
      payload: {
        service_code_list: data.service_code_list,
        service_status: {
          credit: data.service.credit,
          bank: data.service.bank,
          cvs: data.service.cvs,
          atobarai: data.service.atobarai,
        },
        user_status: {
          ...state.user_status,
          cancel_flag: data.cancel_flag,
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const agentName = useMemo(() => {
    if (state.zAccount === "ocnk_subscription") return "：おちゃのこネット定期購入決済";
  }, [state.zAccount]);

  return {
    isLoading,
    canceledFlag,
    closeState,
    closingNoticeText,
    agentName,
  };
};

export default useContainerHooks;
